export default function CustomPanelContent({ file, url, img, longText }) {
	// If we have img or longText, render as HTML content
	if (img || longText) {
		const htmlContent = `
			<!DOCTYPE html>
			<html lang="en">
			<head>
				<meta charset="UTF-8">
				<meta name="viewport" content="width=device-width, initial-scale=1.0">
				<style>
					body {
						margin: 0;
						padding: 20px;
						font-family: Arial, sans-serif;
						line-height: 1.6;
						background-color: #fff;
					}
					img {
						max-width: 100%;
						height: auto;
						display: block;
						margin: 0 auto 20px auto;
						border-radius: 8px;
						box-shadow: 0 2px 8px rgba(0,0,0,0.1);
					}
					.text-content {
						max-width: 800px;
						margin: 0 auto;
						color: #333;
						font-size: 16px;
					}
					.text-content p {
						margin-bottom: 16px;
					}
					.text-content h1, .text-content h2, .text-content h3 {
						color: #2c3e50;
						margin-top: 24px;
						margin-bottom: 16px;
					}
				</style>
			</head>
			<body>
				${img ? `<img src="${img}" alt="Panel content image" />` : ''}
				${longText ? `<div class="text-content">${longText.replace(/\n/g, '<br>')}</div>` : ''}
			</body>
			</html>
		`;

		const blob = new Blob([htmlContent], { type: 'text/html' });
		const htmlUrl = URL.createObjectURL(blob);

		return (
			<iframe 
				src={htmlUrl} 
				width="95%" 
				height="99%" 
				style={{ border: 'none' }}
				onLoad={() => {
					// Clean up the blob URL after iframe loads
					setTimeout(() => URL.revokeObjectURL(htmlUrl), 1000);
				}}
			/>
		);
	}

	// Default behavior for file/url
	return (
		<iframe 
			src={file ? file : url} 
			width="95%" 
			height="99%" 
			style={{ border: 'none' }}
		/>
	);
}

// export default function CustomPanelContent ({file, url, img, longText}) {
// 	return (
// 		<>
// 			{/* <iframe src={file ? file : url} width="100%" height="600px" /> */}
// 			<iframe src={file ? file : url} width="95%" height="99%" />
// 		</>		
// 	)
// }